
let metaobjectColors = [];

// 2. Define GraphQL input
const getMetaobjectData  = () => `
query MetaobjColors{
  metaobjects(type: "color_swatch_single", first: 250) {
    edges {
      node {
        id
        fields {
          value
          key
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}`;

const getMetaobjectDataNext = nextCursor => `
query MetaobjColors{
  metaobjects(type: "color_swatch_single", first: 250, after: "${nextCursor}") {
    edges {
      node {
        id
        fields {
          value
          key
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}`;

const renderObjects = ({data}) => {
  data.metaobjects.edges.forEach((obj) => {
    metaobjectColors.push(obj.node.fields);
  });
  if(data.metaobjects.pageInfo.hasNextPage){
    let nextOptions = createOptionsWithBody(getMetaobjectDataNext(data.metaobjects.pageInfo.endCursor))
    fetch(`https://cans-and-co.myshopify.com/api/graphql`, nextOptions)
    .then(res => res.json())
    .then(renderObjects);
  }else{
    initializeColors();
  }
};


  const options = {
    method: "post",
    headers: {
      "Content-Type": "application/graphql",
      "X-Shopify-Storefront-Access-Token": "3f5fd12c5d810fe14c27292971e9bc77"
    }
  };

  function createOptionsWithBody(body) {
    return {
      ...options,
      body: body
    };
  }


  function initializeColors(){
    let colors = metaobjectColors;
    colors.forEach((color) => {
      let colorProp = color[0];
      let cssProp = color[1];

      if(colorProp && cssProp){
        document.documentElement.style.setProperty(`--${handlelize(cssProp.value)}`, colorProp.value);
      }
    })
  }


  function handlelize (str) {

  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
    .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
    .replace(/\-\-+/g, '-')	// Replaces multiple hyphens by one hyphen
    .replace(/(^-+|-+$)/g, '') // Remove extra hyphens from beginning or end of the string
    .toLowerCase(); // To lowercase

  return str
};

  let intialOptions = createOptionsWithBody(getMetaobjectData());
  fetch(`https://cans-and-co.myshopify.com/api/graphql`, intialOptions)
  .then(res => res.json())
  .then(renderObjects);
